tailwind.config = {
  theme: {
    extend: {
      colors: {
        pop: 'aqua',
      }
    }
  }
}